module.exports = __webpack_public_path__ + "media/images/application/icons/socials/icon-facebook-82c66d9d732f803a7f5b8046ad931cf2.svg";